// Cabinet-level compta routes (docs/projet/interface/): the sidebar's
// Portefeuille and Collecte entries. Each page ships for real page by page —
// until then, a named skeleton.

import { VersEspaceCommun } from "@dust-tt/front/components/compta/VersEspaceCommun";
import { ComptaPlaceholderPage } from "@dust-tt/front/components/pages/compta/ComptaPlaceholderPage";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

export const comptaRoutes: RouteObject[] = [
  // Migration RAG Dust (01/10) : la categorie de l'espace commun, quel que soit son identifiant.
  { path: "espace-commun/:categorie", element: <VersEspaceCommun /> },
  {
    path: "portefeuille",
    element: (
      <ComptaPlaceholderPage
        title="Portefeuille"
        question="Par quoi je commence ma journée ? Le tableau des travaux de tous vos dossiers."
        spec="01-portefeuille.md"
      />
    ),
  },
  {
    path: "collecte",
    element: (
      <ComptaPlaceholderPage
        title="Collecte"
        question="Qu'est-ce qui manque, chez tous mes clients ? Les pièces et les relances du cabinet."
        spec="02-collecte.md"
      />
    ),
  },
];

const PageTachesPlanifiees = withSuspense(
  () => import("@dust-tt/front/components/compta/taches/PageTachesPlanifiees"),
  "PageTachesPlanifiees"
);

const PageConnecteurs = withSuspense(
  () => import("@dust-tt/front/components/compta/PageConnecteurs"),
  "PageConnecteurs"
);

// Maquette de la coquille (01/10) : /w/<espace>/app?chemin=<page de l'app>. La page elle-meme est le
// cadre persistant monte par AgentSurfaceRouterLayout (CadreDeLAppDuChat) : la route ne rend rien.
// Taches planifiees (06/10) : la page des taches s'ouvre dans le rectangle du chat, comme Agents.
export const comptaSurfaceRoutes: RouteObject[] = [
  { path: "app", element: null },
  { path: "taches-planifiees", element: <PageTachesPlanifiees /> },
  // Page Connecteurs ouverte à tous (22/10) : chacun y connecte ses comptes.
  { path: "connecteurs", element: <PageConnecteurs /> },
];
